import { Modal, ModalProps } from "antd";
import { useEffect, useMemo, useState } from "react";
import { SearchIcon } from "../../assets/icons";
import CustomInput from "../../commons/components/CustomInput/CustomInput";
import PrimaryButton from "../../commons/components/PrimaryButton/PrimaryButton";
import {
  FacebookIcon,
  InstagramIcon,
  LinkedlnIcon,
  TrifoodLogo,
  NoAvatar,
  Notification,
  ShoppingCartIcon,
  SmsIcon,
  TwitterIcon,
} from "../../commons/resources";
import { getNormalAttributes } from "../../commons/utils/functions/product";
import styles from "./preview-product.module.scss";
import ProductDetailHeader from "./ProductDetailHeader/ProductDetailHeader";
import Icon from "../../assets/images/Frame 1000003923.svg";
import SurplusProductDetailHeader from "./SurplusProductDetailHeader/SurplusProductDetailHeader";
import { getNormalSurplusAttributes } from "../../commons/utils/functions/surplusMapping";

export const FOOTER_ITEMS = ["Marketplace", "Privacy Policy", "Seller Center", "Terms of Service", "News & Events"];

export const socialMediaItems: ISocialMedia[] = [
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/",
    icon: <LinkedlnIcon />,
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/",
    icon: <FacebookIcon />,
  },
  {
    name: "Twitter",
    link: "https://twitter.com/",
    icon: <TwitterIcon />,
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/",
    icon: <InstagramIcon />,
  },
];
interface PreviewProductProps extends ModalProps {
  className?: string;
  product?: CreateUpdateProductBody;
  surplus?: CreateUpdateSurplusProductBody;
}
const PreviewProduct: React.FC<PreviewProductProps> = (props: PreviewProductProps) => {
  const { className, product, surplus, ...modalProps } = props;
  const [selectedVariants, setSelectedVariants] = useState<any[]>([]);

  const normalAttributes = useMemo(() => {
    if (product) {
      return getNormalAttributes(product, 1);
    } else if (surplus) {
      return getNormalSurplusAttributes(surplus, 1);
    }
  }, [product, surplus]);

  const handleSelectedVariants = (variant: SelectedVariant) => {
    console.log({ variant });
    // if (variant.is_required) {
    //   if (!isIncludedSelectedVariant(variant, selectedVariants)) {
    //     const newSelectedVariants = selectedVariants.filter(
    //       selectedVariant => selectedVariant.attribute_name !== variant.attribute_name
    //     );
    //     setSelectedVariants([...newSelectedVariants, variant]);
    //   }
    // } else {
    //   if (variant.is_multiple_choice) {
    //     if (isIncludedSelectedVariant(variant, selectedVariants)) {
    //       setSelectedVariants(selectedVariants.filter(selectedVariant => !isSelectedVariant(selectedVariant, variant)));
    //     } else {
    //       setSelectedVariants([...selectedVariants, variant]);
    //     }
    //   } else {
    //     if (!isIncludedSelectedVariant(variant, selectedVariants)) {
    //       const newSelectedVariants = selectedVariants.filter(
    //         selectedVariant => selectedVariant.attribute_name !== variant.attribute_name
    //       );
    //       setSelectedVariants([...newSelectedVariants, variant]);
    //     } else {
    //       setSelectedVariants(selectedVariants.filter(selectedVariant => !isSelectedVariant(selectedVariant, variant)));
    //     }
    //   }
    // }

    setSelectedVariants((prev: any) => {
      const clone = [...prev];
      const max = variant.max;

      const objectName = variant.index;
      const isNameExisted = clone.findIndex(item => item.index === objectName);
      let attribute;

      if (isNameExisted < 0) {
        attribute = {
          index: objectName,
          selectedVariants: [variant],
        };
        clone.push(attribute);
      } else {
        if (
          clone[isNameExisted].selectedVariants.find((item: any) => item.attribute_value === variant.attribute_value)
        ) {
          // remove selected variant from index
          clone[isNameExisted] = {
            index: objectName,
            selectedVariants: clone[isNameExisted].selectedVariants.filter(
              (item: any) => item.attribute_value !== variant.attribute_value
            ),
          };
        } else {
          // add selected variant to index
          const handleCheckMaxBeforeAdd = (current: any[], newEl: any, max?: number) => {
            if (!max) return current;

            if (current.length < max) {
              return [...current, newEl];
            } else {
              current[0] = newEl;
              return current;
            }
          };
          handleCheckMaxBeforeAdd(clone[isNameExisted].selectedVariants, variant, max);
          clone[isNameExisted] = {
            index: objectName,
            selectedVariants: handleCheckMaxBeforeAdd(clone[isNameExisted].selectedVariants, variant, max),
          };
        }
      }
      return clone;
    });
  };

  useEffect(() => {
    // const requiredVariant: SelectedVariant[] = [];
    // if (attributes?.length > 0) {
    //   attributes.forEach(attribute => {
    //     if (attribute.is_required) {
    //       let minPriceVariant = attribute.variants[0];
    //       attribute.variants.forEach(variant => {
    //         if (variant.price < minPriceVariant.price) {
    //           minPriceVariant = variant;
    //         }
    //       });
    //       requiredVariant.push({
    //         ...minPriceVariant,
    //         attribute_name: attribute.attribute_name,
    //         is_multiple_choice: attribute.is_multiple_choice,
    //         is_required: attribute.is_required,
    //       });
    //     }
    //   });
    //   setSelectedVariants(requiredVariant);
    // }
  }, []);

  return (
    <Modal footer={<></>} className={[styles.previewProduct, className].join(" ")} {...modalProps}>
      <div className={styles.navigationBar}>
        <TrifoodLogo />
        <CustomInput
          className={styles.search}
          placeholder="Search for items, merchants, user..."
          prefix={<SearchIcon />}
        />
        <div className={styles.menu}>
          <div className={styles.menuItem}>Marketplace</div>
          <div className={styles.menuItem}>News & Events</div>
          <div className={styles.icon}>
            <Notification />
          </div>
          <div className={styles.icon}>
            <ShoppingCartIcon />
          </div>
        </div>
        <div className={styles.profile}>
          <img src={NoAvatar} alt="avatar" />
          <div>Username</div>
        </div>
      </div>
      <div className={styles.content}>
        {product && (
          <ProductDetailHeader
            main_tags={product.main_tags && product.main_tags[0]}
            merchant_store_id={product.merchant_store_id}
            selectedVariants={selectedVariants}
            attributes={normalAttributes as ProductAttribute[]}
            setSelectedVariant={handleSelectedVariants}
            sub_tags={product.sub_tags}
            description={product.description}
            price={product.price}
            images={product.images.length > 0 ? product.images : [Icon]}
            name={product.name}
          />
        )}
        {surplus && (
          <SurplusProductDetailHeader
            selectedVariants={selectedVariants}
            attributes={normalAttributes as SurplusProductAttribute[]}
            setSelectedVariant={handleSelectedVariants}
            description={surplus.description}
            price={surplus.costPrice}
            images={surplus.images.length > 0 ? surplus.images : [Icon]}
            name={surplus.name}
            availableQuantity={surplus.availableQuantity}
          />
        )}
      </div>
      <div className={styles.footer}>
        <div className={styles.categories}>
          <div className={styles.socials}>
            <TrifoodLogo />
            <div className={styles.socialNetworks}>
              {socialMediaItems.map((socialMediaItem: ISocialMedia) => (
                <a href={socialMediaItem.link} target="_blank" rel="noreferrer" key={socialMediaItem.name}>
                  {socialMediaItem.icon}
                </a>
              ))}
            </div>
          </div>
          <div className={styles.items}>
            {FOOTER_ITEMS.map(item => (
              <div>{item}</div>
            ))}
          </div>
          <div className={styles.contact}>
            <div className={styles.title}>Subscribe to Our Newsletter</div>
            <div className={styles.form}>
              <CustomInput className={styles.email} placeholder="Your email address" prefix={<SmsIcon />} />{" "}
              <PrimaryButton className={styles.submitButton}>Submit</PrimaryButton>
            </div>
          </div>
        </div>
        <div className={styles.retangle}></div>
        <div className={styles.copyright}>© {new Date().getFullYear()} by Tridentity. All rights reserved</div>
      </div>
    </Modal>
  );
};

export default PreviewProduct;
